module.exports = __webpack_public_path__ + "assets/images/background.976620e336b8fdaa04b1e0fb0e7cc549.webp";